/**
 * Services roles link event fields per template (e.g. English "Call to Worship" + 4x "Worship" = role "Worship").
 * Linked fields always hold the same people, so editing one field edits all of them.
 */

const norm = (s) => (s ?? '').trim();

export function getRoleForField(config, templateId, fieldName) {
	if (!config?.roles || !templateId || !fieldName) return undefined;
	return config.roles.find(role => (role.fields?.[templateId] ?? []).map(norm).includes(norm(fieldName)));
}

/** Field names linked to the given field (including itself); empty when the field is not linked */
export function getLinkedFieldNames(config, templateId, fieldName) {
	const role = getRoleForField(config, templateId, fieldName);
	return role ? (role.fields[templateId] ?? []).map(norm) : [];
}

/**
 * Copies `memberIds` onto every field in `fields` linked to `fieldName`. Keeps each field's existing member
 * object when the person stays (confirmation state), otherwise uses makeMember(id).
 */
export function syncLinkedFieldMembers(fields, linkedNames, memberIds, makeMember) {
	if (!linkedNames?.length) return fields;
	return fields.map(f => {
		if (!linkedNames.includes(norm(f.field))) return f;
		return {
			...f,
			memberIds: [...memberIds],
			members: memberIds.map(id => f.members?.find(m => m?.id === id) ?? makeMember(id)),
		};
	});
}
